import dayjs from 'dayjs';
import * as React from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import Checkbox from '../../components/common/checkbox';
import DatePicker from '../../components/common/DatePicker';
import IconButton from '../../components/common/IconButton';
import AxiosConfig from '../../utilities/AxiosConfig';
import Dialog from '../../utilities/Dialog';
import { getUTCOffset } from '../../utilities/helper';
import { LedgerReferenceType, LedgerType, PTOSnapshotType } from './types';
import axios from 'axios';
import { AppState } from '../../store';
import { connect } from 'react-redux';
import moment from 'moment';
import './AddRequest.css';

var utc = require('dayjs/plugin/utc')
dayjs.extend(utc)

interface IProps {
    availableHours: number;
    usersPTOPlan: any;
    maxDailyPTOHours: number;
    closeModal: any;
    userInfo: any;
    ledgerReference: any;
    refreshPTOInfo: any;
    userId: any;
    showPtoWarningAlert: boolean;
    setShowPtoWarningAlert: (showPtoWarningAlert: boolean) => void;
    sortablePtoData: LedgerType[];
    ptoData: {
        ledger: Array<LedgerType>;
        pending: Array<number>;
        snapshot: PTOSnapshotType;
        ArchivedYears: string[]
    }
    setPtoData: React.Dispatch<React.SetStateAction<{
        ledger: Array<LedgerType>;
        pending: Array<number>;
        snapshot: PTOSnapshotType;
        ArchivedYears: string[]
    }>>
    isOwnPto: boolean;
    getPtoSnapshotInfo: Function;
}

const oneDay: number = 1000 * 60 * 60 * 24;

const AddRequest: React.FC<IProps> = (props: IProps) => {
    const { usersPTOPlan, maxDailyPTOHours, userInfo, closeModal, ledgerReference, availableHours,
        getPtoSnapshotInfo, userId, showPtoWarningAlert, setShowPtoWarningAlert, sortablePtoData, ptoData, setPtoData, isOwnPto } = props;
    const [saving, setSaving] = React.useState(false);
    const [isAllDay, setIsAllDay] = React.useState(true);
    const [numOfDays, setNumOfDays] = React.useState(1);
    const [ptoWarningText, setPtoWarningText] = React.useState("");
    const [holidays, setHolidays] = React.useState(null as unknown as [])
    const [newEntry, setNewEntry] = React.useState({
        deletedDatets: null,
        employeeComment: "",
        endTimets: dayjs.utc().hour(23).minute(59).second(0).millisecond(0).valueOf(),
        entryDatets: dayjs.utc().startOf("day").valueOf(),
        ledgerEntryTypeId: (Number(props.userInfo.id) === Number(userId)) ? { label: "PTO Request", value: 4 } : null,
        ledgerId: 0,
        managerComment: "",
        planId: usersPTOPlan?.id || 0,
        quantity: maxDailyPTOHours,
        startTimets: dayjs().utc().startOf("day").valueOf(),
        status: "Pending",
        userId: userInfo.UserId,
        utcOffset: getUTCOffset(),
        ManagerCommenter: "",
        EmployeeCommenter: "",
        ManagerCommentDatets: null,
        EmployeeCommentDatets: null,
        IsUnplanned: false,
    } as any);
    
    const handleIsAllDayToggle = async () => {
        let updatedEntry: any = { ...newEntry };
        const nextState: boolean = !isAllDay;
        let numberOfDays: number = (updatedEntry.endTimets - updatedEntry.startTimets) / oneDay;
        if (numberOfDays > 1 && !nextState) {
            setPtoWarningText("Multiple days can only be entered as All Day.");
            setShowPtoWarningAlert(!showPtoWarningAlert);
            return;
        } else if (nextState && updatedEntry.quantity < maxDailyPTOHours) {
            updatedEntry.quantity = maxDailyPTOHours;
        } else if (!nextState && updatedEntry.quantity >= maxDailyPTOHours) {
            updatedEntry.quantity = 0;
        }
        setIsAllDay(nextState);
    }
    //cgm 041322 =>> get list of ELM paid holidays
    const getHolidays = (profitCenterId: number | string) => {
        axios.get(process.env.REACT_APP_API_URL + `/api/pto/ptodata/${profitCenterId}/${Date.now().valueOf()}/${Date.now().valueOf()}/false`, AxiosConfig.configValue("min"))
            .then((res: any) => {
                setHolidays(res.data.HolidayDates);
            })
            .catch((err: any) => {
                AxiosConfig.handleError(err);
            })
    }

    const handleDateChange = async (value: any, name: string) => {
        let updatedEntry = { ...newEntry };
        let totalHoursNoHolidays;
        let WORK_HOURS_PER_DAY = 8;
        const selectedDate: any = value.valueOf();
        if (name === "entryDatets") {
            updatedEntry.entryDatets = selectedDate;
            updatedEntry.startTimets = selectedDate;
            if (selectedDate > newEntry.endTimets) {
                updatedEntry.endTimets = dayjs.utc(selectedDate).hour(23).minute(59).second(0).millisecond(0).valueOf();
            }
        } else {
            updatedEntry.endTimets = selectedDate;
        }     
        let numberOfDays: number = (updatedEntry.endTimets - updatedEntry.startTimets) / oneDay;
        if (numberOfDays > 1 || isAllDay) {
            setIsAllDay(true);
            if (numberOfDays < 0) {
                updatedEntry.quantity = 0;
            } else {
                totalHoursNoHolidays = calculateHours(moment(Math.round(numberOfDays)), moment(updatedEntry.startTimets).day());
                totalHoursNoHolidays -= checkIfContainsHoliday(holidays, moment(updatedEntry.startTimets), moment(updatedEntry.endTimets));
                //tmp 03/17/2025 => put setNumOfDays here and calculate 
                setNumOfDays(totalHoursNoHolidays/WORK_HOURS_PER_DAY);
            }
        }
        updatedEntry.quantity = totalHoursNoHolidays ;
        setNewEntry(updatedEntry);
    }

    const handleChange = (e: any) => {
        setNewEntry({ ...newEntry, [e.target.name]: e.target.value });
    }

    const handleQuantityClick = async (e: any) => {
        e.preventDefault();
        if (isAllDay) {
            setPtoWarningText("Cannot edit hours when All Day is checked.");
            setShowPtoWarningAlert(!showPtoWarningAlert);
            return;
        }
    }

    //cgm 041322 =>> attempting to disable weekends on the calendar.  This does not work.
    const disableWeekends = (current: any) => {
        return current.day() !== 0 && current.day() !== 6
    }

    //cgm 041322 =>> Check if errors exist and provide notification for PTO requests
    const checkPTOEntryForErrors = () => {
        if (newEntry.endTimets < newEntry.entryDatets) {
            setPtoWarningText("Start date must come before end date.");
            setShowPtoWarningAlert(!showPtoWarningAlert);
        }
        if (newEntry.ledgerEntryTypeId === null) { //We are not an overly polite Portal. ;-)
            setPtoWarningText("You must select an Entry Type before saving");
            setShowPtoWarningAlert(!showPtoWarningAlert);
            return true;
        }
        if (newEntry.quantity <= 0 && newEntry.ledgerEntryTypeId?.value !== 2) {
            setPtoWarningText("Quantity must be greater than 0.");
            setShowPtoWarningAlert(!showPtoWarningAlert);
            return true;
        }
    }

    //cgm 041222 =>> converting the holiday dates to moments in order to loop through and see if they are a part of the requested time period.
    let holidayMoments: any = [];
    const getHolidayMoments = (holidays: any) => {
        holidays.forEach((holiday: any) => holidayMoments.push(moment(holiday.HolidayDate)))
    }

    //cgm 041322 =>> get total hours minus weekends for salaried users
    //tmp 03/17/2025 =>> use this anti-weekend logic to update the Selected Days instead of making redundant logic
    const calculateHours = (dayTotal: any, startingDay: any) => {
        getHolidayMoments(holidays);
        let dayCount = dayTotal;
        let dayOfWeek = startingDay;
        let totalHours = 0;
        while (dayCount > 0 && totalHours < 4000) {
            if (dayOfWeek === 6) {
                dayOfWeek = 0;
            } else if (dayOfWeek === 5) {
                dayOfWeek++;
            } else {
                dayOfWeek++;
                totalHours += maxDailyPTOHours;
            }
            dayCount--;
            //console.log("Hour Total", totalHours, dayOfWeek)
        }
        return totalHours;
    }   
    
    //cgm 041322 =>> Check if pto entry includes a holiday and return the amount of holiday hours at user's max hour rate
    const checkIfContainsHoliday = (holidayArray: typeof holidays, startDate: any, endDate: any) => {
        let holidayCount = 0;
        holidayArray.forEach((holiday: any) => {
            let dayToCompare = moment(holiday.HolidayDate);
            const isBetween = dayToCompare.isBetween(startDate, endDate);
            isBetween && holidayCount++;
        })
        if (userInfo.PayTypeId === 2) {
            return holidayCount * maxDailyPTOHours;
        } else {
            return 0;
        }
    }

    const addPTOEntry = async () => {
        if (!checkPTOEntryForErrors()) {
            let entryToAdd: any = { ...newEntry };
            let ledgerEntryType = entryToAdd.ledgerEntryTypeId;
            entryToAdd.ledgerEntryTypeId = ledgerEntryType.value;
            entryToAdd.quantity = newEntry.quantity;
            entryToAdd.createdBy = userInfo.FirstName + " " + userInfo.LastName
            setSaving(true);
            axios.post(process.env.REACT_APP_API_URL + "/api/pto/ledger", entryToAdd, AxiosConfig.configValue("min"))
                .then(async (res: any) => {
                    //cgm 060222 =>> next 8 lines update the front end array for the ptoData
                    if (sortablePtoData !== null && sortablePtoData !== undefined && res.data.LedgerEntry) {
                        sortablePtoData.push(res.data.LedgerEntry);
                    } else if (sortablePtoData !== null && sortablePtoData !== undefined && res.data.length > 1) {
                        for (let i = 0; i < res.data.length; i++) {
                            sortablePtoData.push(res.data[i].LedgerEntry);
                        }
                    }
                    setPtoData({ ...ptoData, ledger: sortablePtoData });
                    if (res.data.Error?.success === false && res.data.PTOLedger?.showAllowNegativeOverride === true) {
                        let message: string = res.Error?.message || "";
                        const prompt: any = new Dialog({ type: "confirm", trueText: "Yes", falseText: "No", message: `${message} Would you like to override?` });
                        const answer: any = await prompt.show();
                        if (!answer) return;
                        setNewEntry({ ...newEntry, AllowNegativeOverride: true });
                        return;
                    }
                    if (Array.isArray(res.data)) {
                        let message: string = "";
                        let showOverride: boolean = false;
                        res.data.forEach((res: any) => {
                            if (!res.Error?.success && res.PTOLedger?.showAllowNegativeOverride) {
                                message = res.Error?.message;
                                showOverride = true;
                            }
                        });
                        if (showOverride) {
                            const prompt: any = new Dialog({ type: "confirm", trueText: "Yes", falseText: "No", message: `${message} Would you like to override?` });
                            const answer: any = await prompt.show();
                            if (!answer) return;
                            setNewEntry({ ...newEntry, AllowNegativeOverride: true });
                            return;
                        }
                    }
                    if (Array.isArray(res.data)) {
                        if (AxiosConfig.checkArrayOfResponses(res.data, {
                            alertOnSuccess: true,
                            successMessage: "Added Ledger Entry!",
                            showSnackbar: true,
                            snackBar: { manual: true }
                        })) {
                            closeModal();
                        }
                    } else {
                        if (AxiosConfig.checkResponse(res.data, {
                            alertOnSuccess: true,
                            successMessage: "Added Ledger Entry!",
                            showSnackbar: true,
                            snackBar: { manual: true }
                        })) {
                            closeModal();
                        }
                    }
                })
                .catch((err: any) => {
                    AxiosConfig.handleError(err);
                })
                .finally(() => {
                    setSaving(false);
                    getPtoSnapshotInfo();
                    props.refreshPTOInfo();
                })
        }
    }

    const handleClosePtoWarning = () => {
        setShowPtoWarningAlert(!showPtoWarningAlert);
    }

    const pToWarningModal = () => {
        return (
            <>
                <Modal.Header>
                </Modal.Header>
                <Modal.Body >
                    {ptoWarningText}
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-outline-primary' onClick={handleClosePtoWarning}>Close</button>
                </Modal.Footer>
            </>
        )
    }

    React.useEffect(() => {
        getHolidays(props.userInfo.HomeProfitCenterId);
        if (Number(props.userInfo.UserId) === Number(userId)) {
            const PTORequestType: LedgerReferenceType | null = ledgerReference?.ledgerEntryTypes.find((entry: LedgerReferenceType) => entry.id === 4);
            if (PTORequestType) {
                setNewEntry({
                    ...newEntry,
                    ledgerEntryTypeId: { label: PTORequestType?.text, value: PTORequestType?.id }
                })
            }
        }
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [ledgerReference])

    //? Logic to handle AllowNegativeOverride
    React.useEffect(() => {
        if (newEntry.AllowNegativeOverride) {
            addPTOEntry();
        }
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [newEntry.AllowNegativeOverride])

    return (
        showPtoWarningAlert ?
            pToWarningModal() :
            <>
                <Modal.Body>
                    <h4 className='label-spacer'><strong>{userInfo.LastName}, {userInfo.FirstName}</strong></h4>
                    <form>
                        <strong className='label-spacer'>Available Hours: {availableHours}</strong>
                        <Checkbox onChange={handleIsAllDayToggle} isChecked={isAllDay} label={`All Day (${maxDailyPTOHours} Hours)`} />
                        <div className="d-flex flex-column p-1 col-12">
                            <strong className='label-spacer'>Entry Type</strong>
                            <Select
                                className='pto-request-entry-select'
                                options={ledgerReference?.ledgerEntryTypes.map((lr: LedgerReferenceType) => ({ value: lr.id, label: lr.text }))}
                                value={newEntry?.ledgerEntryTypeId}
                                onChange={(val: any) => {
                                    if (val.value === 2) {
                                        setNewEntry({ ...newEntry, ledgerEntryTypeId: val, status: "Approved" })
                                    } else {
                                        setNewEntry({ ...newEntry, ledgerEntryTypeId: val });
                                    }
                                }}
                                styles={{
                                    menu: (provided: any) => ({ ...provided, zIndex: 5 })
                                }}
                            />
                            {
                                (newEntry.ledgerEntryTypeId !== null && newEntry.ledgerEntryTypeId !== undefined) &&
                                    (newEntry.ledgerEntryTypeId.value === 4 && props.userInfo.PayTypeId === 1) ?
                                    <Checkbox isChecked={newEntry.IsUnplanned} onChange={() => setNewEntry({ ...newEntry, IsUnplanned: !newEntry.IsUnplanned })} label={`Time Unplanned?`} /> :
                                    null
                            }
                        </div>
                        <div className="d-flex p-1 flex-column col-12">
                            <div className="d-flex  flex-row justify-content-between align-items-center">
                                <strong className='label-spacer'>Start Date</strong>
                                <strong className='label-spacer'>Selected Days: {Math.round(numOfDays)}</strong>
                            </div>
                            <DatePicker
                                //cgm 041322 =>> attempt at disabling weekends on the calendar
                                isValidDate={disableWeekends}
                                type="input"
                                name="entryDatets"
                                showTime={false}
                                onChange={handleDateChange}
                                value={newEntry.entryDatets}
                                useCloseCallback={true}
                                isUTC={true}
                            />
                        </div>
                        <div className="d-flex flex-column p-1 col-12">
                            <strong className='label-spacer'>End Date</strong>
                            <DatePicker
                                type="input"
                                name="endDatets"
                                showTime={false}
                                onChange={handleDateChange}
                                value={newEntry.endTimets}
                                useCloseCallback={true}
                                isUTC={true}
                            />
                        </div>
                        <div className="d-flex flex-column p-1 col-12" onClick={handleQuantityClick}>
                            <strong className='label-spacer'>Hours</strong>
                            <input
                                name="quantity"
                                disabled={isAllDay}
                                type="number"
                                className="form-control"
                                value={newEntry.quantity}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="d-flex flex-column p-1 col-12">
                            <strong className='label-spacer'>Comments</strong>
                            {
                                isOwnPto ?
                                    <textarea name="employeeComment" onChange={handleChange} style={{ minHeight: 150, minWidth: "50%" }} value={newEntry.employeeComment} />
                                    : <textarea name="managerComment" onChange={handleChange} style={{ minHeight: 150, minWidth: "50%" }} value={newEntry.managerComment} />
                            }
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <IconButton disabled={saving} onClick={() => closeModal()} buttonClassName="action-text-danger" icon="close">Close</IconButton>
                    <IconButton disabled={saving} showSpinner={saving} onClick={addPTOEntry} buttonClassName="action-text" icon="save">
                        Save
                    </IconButton>
                </Modal.Footer>
            </>
    )
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
})

export default connect(mapStateToProps)(AddRequest);